import axios from "axios";

import React from "react";
import { GlobalError } from "../../../components/errors/GlobalError";
import { GetApplication, GetApplicationVersion } from "utilityFunctions";


export const PostComment =
  (
    firstName: string,
    lastName: string,
    email: string,
    comment: string,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    onCompleted: any
  ) =>
  async () => {
    setLoading(true);
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const postCommentRequest ={application: await GetApplication(),
      applicationVersion: GetApplicationVersion(), 
      email,
      firstName,
      lastName,
      comment,}

    try {
      console.log("this is the postCommentRequest", postCommentRequest);
      const postCommentResponse = await axios.post(
        `${BASE_URL}/api/users/comments`,
        postCommentRequest
      );
      console.log("this is the postCommentResponse", postCommentResponse);
      if (postCommentResponse.status === 200) {
        setLoading(false);
        onCompleted();
      }
    } catch (error: any) {
      GlobalError(error);
      setLoading(false);
    }
  };
